import { render } from "./TaskList.vue?vue&type=template&id=edd7a8b6"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskList.vue?vue&type=style&index=0&id=edd7a8b6&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/home/runner/work/pulse/pulse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__